import { HelpCenterResponse } from '../services/helpCenter';
import { shadowRoot } from '../shadowRoot';

const JS_EVENTS = {
  onAppStart: 'onAppStart',
};

export function loadCustomJS(
  data: HelpCenterResponse,
  targetRoot: ShadowRoot | Document = shadowRoot,
  jsEvent: string = JS_EVENTS.onAppStart
) {
  const { custom_js } = data.customization || {};

  // Always remove existing custom JS script element to prevent scripts from previous UUIDs persisting
  const existingScript = targetRoot?.getElementById('ostro-custom-js');
  if (existingScript) {
    existingScript?.remove();
  }

  if (!custom_js || !targetRoot) {
    return;
  }

  if (custom_js && jsEvent in custom_js) {
    try {
      const customJSScriptElement = document.createElement('script');
      customJSScriptElement.id = 'ostro-custom-js';
      customJSScriptElement.type = 'text/javascript';

      // Use Function constructor to handle syntax errors safely
      const wrappedJS = `
        try {
          const userFunction = new Function(\`${custom_js[jsEvent].replace(/`/g, '\\`')}\`);
          userFunction();
        } catch (error) {
          console.error('Error executing custom JavaScript:', error);
          console.error('Custom JS code:', \`${custom_js[jsEvent]}\`);
        }
      `;

      customJSScriptElement.innerHTML = wrappedJS;
      targetRoot.appendChild(customJSScriptElement);
    } catch (error) {
      console.error('Error creating custom JavaScript element:', error);
    }
  }
}
